module.exports = __webpack_public_path__ + "img/collection-empty-pic.d2aace6d.png";